import { AuthorRoles, ChatMessageType, IChatMessage } from '../models/ChatMessage';
import { ActiveUserInfo } from '../../redux/features/app/AppState';

/**
 * Local-only bubble for an image the customer sent to the agent over the LiveChat upload. It rides
 * `localImagePreview`, so like the AI paste echo it is never persisted and is gone after a reload.
 */
export const buildLocalImageEcho = (
    chatId: string,
    user: ActiveUserInfo | undefined,
    base64: string,
    mimeType: string,
    content: string,
): IChatMessage => ({
    chatId,
    timestamp: new Date().getTime(),
    userId: user?.id ?? '',
    userName: user?.username ?? '',
    content,
    type: ChatMessageType.Message,
    authorRole: AuthorRoles.User,
    localImagePreview: `data:${mimeType};base64,${base64}`,
    isLocalEcho: true,
});

/** An image the handling agent sent, as pushed on the customer hub's `ReceiveAgentImage` event. */
export interface AgentImagePush {
    imageId: string;
    mimeType: string;
    base64: string;
    userName: string;
    timestamp: string;
}

/**
 * Support bubble for an image the handling agent sent. Like the customer's own echo it is UI-only:
 * the bytes arrive inline on the push and nothing restores the row after a reload.
 */
export const buildAgentImageMessage = (chatId: string, image: AgentImagePush): IChatMessage => ({
    chatId,
    id: image.imageId,
    timestamp: new Date(image.timestamp).getTime(),
    userId: '',
    userName: image.userName,
    content: '',
    type: ChatMessageType.Message,
    authorRole: AuthorRoles.Participant,
    localImagePreview: `data:${image.mimeType};base64,${image.base64}`,
});
